import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M21 19H3C1.89543 19 1 18.1046 1 17V16H3V7C3 5.89543 3.89543 5 5 5H19C20.1046 5 21 5.89543 21 7V16H23V17C23 18.1046 22.1046 19 21 19ZM5 7V16H19V7H5Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Laptop"
);
